import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  children?: ReactNode;
}

/** Framed empty panel on a faint dot grid — for screens and lists with nothing in them yet. */
export function EmptyState({ icon: Icon, title, description, children }: EmptyStateProps) {
  return (
    <section className="relative overflow-hidden rounded-xl border border-line bg-surface">
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(var(--color-line)_1px,transparent_1px)] [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)] bg-[size:18px_18px]"
      />
      <div className="relative flex flex-col items-center px-6 py-16 text-center">
        <div className="mb-5 grid size-12 place-items-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/20">
          <Icon className="size-5" strokeWidth={1.75} />
        </div>
        <h2 className="text-base font-semibold text-fg">{title}</h2>
        <p className="mt-1.5 max-w-md text-sm text-muted">{description}</p>
        {children && <div className="mt-6">{children}</div>}
      </div>
    </section>
  );
}
